// extracted by mini-css-extract-plugin
export default {"container":"MM-z","topReviewHeading":"NM-z","criticalReview":"OM-z","favorableReview":"PM-z","vsSeparator":"QM-z"};